import "../../../scss/notification-popup.scss";

type NotificationPopupProps = {
    isOpen: boolean;
    onClose: () => void;
    message: string;
};

const NotificationPopup: React.FC<NotificationPopupProps> = ({ isOpen, onClose , message}) => {
    if (!isOpen) return null;

    return (
        <div className="no-products-modal__overlay">
            <div className="no-products-modal__content">
                <button className="no-products-modal__close" onClick={onClose}>
                    &times;
                </button>
                <div className="no-products-modal__message">
                    <p>{message}</p>
                </div>
            </div>
        </div>
    );
};

export default NotificationPopup;